import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "breadcrumb-wrapper"
};
const _hoisted_2 = {
  class: "breadcrumb"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 0,
  class: "separator"
};
export default /*@__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  props: {
    items: {}
  },
  emits: ['click'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const handleClick = (item, index) => {
      emit('click', item, index);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
        return _openBlock(), _createElementBlock("span", {
          key: index,
          class: _normalizeClass({
            active: index === __props.items.length - 1
          })
        }, [_createElementVNode("span", {
          class: "text",
          onClick: $event => handleClick(item, index)
        }, _toDisplayString(item.label), 9, _hoisted_3), index < __props.items.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_4, ">>")) : _createCommentVNode("", true)], 2);
      }), 128))])]);
    };
  }
});